var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDexe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.473 25.29A13.948 13.948 0 0 0 30 16c0-7.732-6.268-14-14-14S2 8.268 2 16s6.268 14 14 14c2.168 0 4.222-.493 6.054-1.373L17.34 23.77c-1.094.18-3.899-.027-6.364-2.277s-2.5-5.002-2.21-6.096l17.707 9.894zM11.445 10.24l12.191 7.1c.38-1.831.228-5.962-3.416-7.838-3.644-1.875-7.368-.29-8.775.737z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDexe);
export default __webpack_public_path__ + "static/media/DEXE.489dce9a7af602594d09af0b5c664bff.svg";
export { ForwardRef as ReactComponent };